import Modal from "react-modal";
import { ModalTitle } from "styles/Modal";
import closeImg from "../../assets/close.svg";
import { FieldValues, SubmitHandler, useForm } from "react-hook-form";
import { InputGroup } from "styles/InputGroup";
import { Button } from "styles/Button";
import { Form } from "styles/Form";
import { Buttons } from "components/MessageForm/styles";
import { Input } from "components/Form/Input";
import { useEditAgentAbsence } from "hooks/mutations/useEditAgentAbsence";
import { AgentAbsence } from "types/SupportAgent";
import { useEffect } from "react";
import { CheckboxRow } from "components/AddAbsenceModal/styles";

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
  absence: AgentAbsence;
};

export function EditAbsenceModal({ isOpen, onRequestClose, absence }: Props) {
  const { handleSubmit, register, control, reset, setValue, formState: { isSubmitting } } = useForm<FieldValues>({
    defaultValues: {
      reason: '',
      starts_at: '',
      ends_at: '',
      auto_reactivate: true,
    },
  });

  const editAbsence = useEditAgentAbsence();

  useEffect(() => {
    setValue('reason', absence.reason ?? '');
    setValue('starts_at', absence.starts_at?.slice(0, 16) ?? '');
    setValue('ends_at', absence.ends_at?.slice(0, 16) ?? '');
    setValue('auto_reactivate', absence.auto_reactivate);
  }, [absence, setValue]);

  function handleClose() {
    reset();
    onRequestClose();
  }

  async function handleSubmitForm({ reason, starts_at, ends_at, auto_reactivate }: any) {
    await editAbsence.mutateAsync({
      absence,
      data: {
        reason: reason || undefined,
        starts_at,
        ends_at,
        auto_reactivate: Boolean(auto_reactivate),
      },
    });
    handleClose();
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      overlayClassName="react-modal-overlay"
      className="react-modal-content"
    >
      <button type="button" onClick={handleClose} className="react-modal-close">
        <img src={closeImg} alt="Fechar modal" loading="lazy" />
      </button>

      <div>
        <ModalTitle>Editar ausência — {absence.user?.name}</ModalTitle>
        <Form onSubmit={handleSubmit(handleSubmitForm as SubmitHandler<FieldValues>)}>
          <InputGroup>
            <Input
              control={control}
              type="text"
              name="reason"
              id="reason"
              label="Motivo"
              maxLength={255}
              fullwidth
            />
          </InputGroup>

          <InputGroup>
            <Input
              control={control}
              type="datetime-local"
              name="starts_at"
              id="starts_at"
              label="Início (data e hora)"
              fullwidth
            />
          </InputGroup>

          <InputGroup>
            <Input
              control={control}
              type="datetime-local"
              name="ends_at"
              id="ends_at"
              label="Retorno (data e hora)"
              fullwidth
            />
          </InputGroup>

          <InputGroup>
            <CheckboxRow>
              <input type="checkbox" id="auto_reactivate" {...register('auto_reactivate')} />
              <label htmlFor="auto_reactivate">Reativar automaticamente ao fim do período</label>
            </CheckboxRow>
          </InputGroup>

          <InputGroup>
            <Buttons>
              <Button type="submit" fullwidth disabled={isSubmitting}>
                {isSubmitting ? 'Salvando...' : 'Salvar'}
              </Button>
              <Button type="button" onClick={handleClose}>Cancelar</Button>
            </Buttons>
          </InputGroup>
        </Form>
      </div>
    </Modal>
  );
}
